<template>
    <div>
        入寮申請
    </div>
</template>
      
<script>
export default {};
</script>
      
<style>
</style>
      